package ir.yusefpasha.sections

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.FontStyle
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.components.layout.numColumns
import com.varabyte.kobweb.silk.components.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.components.style.toModifier
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import ir.yusefpasha.components.SectionTitle
import ir.yusefpasha.components.SkillBar
import ir.yusefpasha.models.Section
import ir.yusefpasha.models.Skill
import ir.yusefpasha.models.Theme
import ir.yusefpasha.style.AboutImageStyle
import ir.yusefpasha.style.AboutTextStyle
import ir.yusefpasha.util.Constants
import ir.yusefpasha.util.ObserveViewportEntered
import ir.yusefpasha.util.Res
import ir.yusefpasha.util.animatedNumbers
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Composable
fun AboutSection() {
    val breakpoint = rememberBreakpoint()
    Box(
        modifier = Modifier
            .id(Section.About.id)
            .maxWidth(Constants.SECTION_WIDTH.px)
            .padding(topBottom = 150.px),
        contentAlignment = Alignment.Center
    ) {
        AboutContent(breakpoint)
    }
}

@Composable
private fun AboutContent(breakPoint: Breakpoint) {
    Column(
        modifier = Modifier
            .fillMaxWidth(
                if (breakPoint >= Breakpoint.MD) 100.percent
                else 90.percent
            )
            .maxWidth(1200.px),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        SimpleGrid(
            modifier = Modifier.fillMaxWidth(
                if (breakPoint >= Breakpoint.MD) 90.percent
                else 100.percent
            ),
            numColumns = numColumns(base = 1, md = 2)
        ) {
            if (breakPoint >= Breakpoint.MD) {
                AboutImage()
            }
            AboutMe(breakPoint)
        }
    }
}

@Composable
private fun AboutImage() {
    Box(modifier = Modifier.fillMaxWidth(), contentAlignment = Alignment.Center) {
        Image(
            modifier = AboutImageStyle.toModifier().fillMaxWidth(80.percent),
            src = Res.Image.ABOUT,
            desc = "About Image"
        )
    }
}

@Composable
private fun AboutMe(breakpoint: Breakpoint) {

    val scope = rememberCoroutineScope()

    var viewPortEntered by remember { mutableStateOf(false) }

    val animatedPercentage = remember { mutableStateListOf(0, 0, 0, 0, 0) }

    ObserveViewportEntered(
        sectionId = Section.About.id,
        distanceFromTop = 200.0
    ) {
        viewPortEntered = true
        Skill.values().forEach { skill ->
            scope.launch {
                animatedNumbers(
                    number = skill.percentage.value.toInt(),
                    onUpdate = {
                        animatedPercentage[skill.ordinal] = it
                    }
                )
            }
        }
    }

    Column(modifier = Modifier.fillMaxWidth(), verticalArrangement = Arrangement.Center) {
        SectionTitle(section = Section.About)
        P(
            attrs = AboutTextStyle.toModifier()
                .margin(top = 25.px)
                .maxWidth(500.px)
                .fontFamily(Constants.FONT_FAMILY)
                .fontSize(if (breakpoint >= Breakpoint.LG) 18.px else 14.px)
                .fontWeight(FontWeight.Normal)
                .fontStyle(FontStyle.Italic)
                .color(Theme.Secondary.rgb)
                .toAttrs()
        ) {
            Text(
                """
                Creative, Full of Energy, Always Learning New Technologies and Modern methods...
                Interested in TeamWork and doing Big-Projects and Special Challenges...
                If Others Can Do it, so Can I... :)
            """.trimIndent()
            )
        }
        Skill.values().forEach { skill ->
            SkillBar(
                name = skill.name,
                index = skill.ordinal,
                percentage = if (viewPortEntered) skill.percentage else 0.percent,
                animatedPercentage = if (viewPortEntered) animatedPercentage[skill.ordinal] else 0
            )
        }
    }
}